import Actions               from 'Redux/Actions';
import { InvoiceRepository } from 'Domain/Repositories';
import { ofType }            from 'redux-observable';
import { from, EMPTY }       from 'rxjs';
import { mergeMap }          from 'rxjs/operators';
import { TEpic }             from 'Redux/Config';
import { message }           from 'antd';

export const sendInvoicePdfEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.sendInvoicePdfRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        InvoiceRepository.sendInvoicePdf(id)
          .then(() => {
            message.success('Rechnung wurden erfolgreich erneut versendet.');

            return Actions.sendInvoicePdfSuccess();
          })
          .catch(error => Actions.sendInvoicePdfFailure({ error })),
      );
    }),
  );
};
